import { accessControl } from 'lib-shared-access-control';
import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { addCallerActions } from '../../shared/addCallerModal/actions/addCaller';
import * as telephonyActions from '../../telephony/actions/telephony';
import { actions } from '../actions/conversation';
import PhoneForm from '../components/PhoneForm';

const { telephonySetHold, telephonySetMute } = telephonyActions.actions;
const { addCallerSetOnHoldRequest, addCallerRemoveCallerRequest } =
  addCallerActions;

const mapStateToProps = (state) => {
  const metaConversation = state.conversation.metaConversation;
  const initialChannel =
    state.conversation.metaConversation.conversation.initial_channel;
  const csid = metaConversation.conversation.id;
  const recordingEnabled =
    metaConversation.conversation.assignment !== null &&
    metaConversation.conversation.attributes &&
    metaConversation.conversation.attributes.record_conversation === 'true'
      ? true
      : false;
  const isCurrentlyRecording =
    metaConversation.conversation.attributes &&
    metaConversation.conversation.attributes.record_conversation === 'true' &&
    metaConversation.conversation.attributes.recording_pause_status === 'paused'
      ? false
      : true;
  let canListen = false;
  let isListening = false;

  const hasConversationCallAccess =
    accessControl.hasAccess('conversation.call');

  if (
    hasConversationCallAccess &&
    // Some orgs does not allow listen in to other agents phone calls.
    state.settings.organization.featureflags.is_listen_in_allowed === true &&
    metaConversation.conversation.is_closed === false &&
    metaConversation.conversation.assignment !== null &&
    metaConversation.isAssignedToMe === false
  ) {
    if (
      (initialChannel === 'pstnphone' &&
        metaConversation.conversation.live_assesment &&
        metaConversation.conversation.live_assesment.is_end_user_connected ===
          true) ||
      (initialChannel === 'callback' &&
        metaConversation.conversation.is_callback_consumed === false)
    ) {
      canListen = true;
      if (
        state.telephony.currentCall !== null &&
        state.telephony.isOnMute === true
      ) {
        if (
          state.telephony.currentCall.csid !== undefined &&
          metaConversation.conversation.id === state.telephony.currentCall.csid
        ) {
          isListening = true;
        }
      } else if (
        state.telephony.currentCall !== null &&
        state.telephony.isOnMute === false
      ) {
        if (
          state.telephony.currentCall.csid !== undefined &&
          metaConversation.conversation.id === state.telephony.currentCall.csid
        ) {
          isListening = true;
        }
      }
    }
  }

  return {
    active: state.telephony.currentCall?.csid === csid,
    csid: csid,
    requesterId: metaConversation.requester?.id,
    recordingAsyncStatus: state.conversation.asyncStatus.recording,
    muteAsyncStatus: state.telephony.meta.mute,
    holdAsyncStatus: state.telephony.meta.hold,
    listenAsyncStatus: state.twilio.meta.connectCall,
    isAssigned: metaConversation.isAssignedToMe,
    canListen: canListen,
    isListening: isListening,
    muted: state.telephony.isOnMute,
    onHold: state.telephony.isOnHold,
    recordingEnabled: recordingEnabled,
    isCurrentlyRecording: isCurrentlyRecording,
    assignedAt: metaConversation.conversation.assignment?.assigned_at,
    authors: metaConversation.conversation.authors,
    agentId: metaConversation.conversation.assignment?.agent_id,
    extraParties: metaConversation.extraParties,
    callersOnHold: metaConversation.callersOnHold,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    conversationPauseCallRecording: bindActionToPromise(
      dispatch,
      actions.conversationPauseCallRecording,
    ),
    conversationResumeCallRecording: bindActionToPromise(
      dispatch,
      actions.conversationResumeCallRecording,
    ),
    telephonySetHold: bindActionToPromise(dispatch, telephonySetHold),
    telephonySetMute: bindActionToPromise(dispatch, telephonySetMute),
    twilioConnectCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioConnectCall,
    ),
    twilioDisconnectCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioDisconnectCall,
    ),
    telephonySendDigits: (digit: string) =>
      dispatch(twilioActions.twilioSendDigits({ digit: digit })),
    addCallerRemoveCallerRequest: bindActionToPromise(
      dispatch,
      addCallerRemoveCallerRequest,
    ),
    addCallerSetOnHoldRequest: bindActionToPromise(
      dispatch,
      addCallerSetOnHoldRequest,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneForm);
